exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fly-competitor-header[data-v-67f9acdb]{position:absolute;top:20px;right:21px}.competitors-header[data-v-67f9acdb]{justify-content:space-between;align-items:flex-start}.select-competitors[data-v-67f9acdb]{width:100%;margin-right:40px}.competitors-settings[data-v-67f9acdb]{width:430px;justify-content:flex-end;align-items:center}#compatitorsForAnalysis[data-v-67f9acdb],#fieldsForHeader[data-v-67f9acdb]{max-height:400px;overflow:auto}.no-wrap[data-v-67f9acdb]{white-space:nowrap}", ""]);

// exports
